import React, { useEffect, useState } from "react";
import { DayPicker, addToRange } from "react-day-picker";

import "react-day-picker/dist/style.css";

import DateRangeLabel from "./DateRangeLabel";

const numberOfMonths = 1;

const DateRangePicker = ({
  classes = [],
  label,
  startDate,
  endDate,
  onSelection,
  align = "center",
}) => {
  const [range, setRange] = useState({
    from: startDate ? new Date(startDate) : undefined,
    to: endDate ? new Date(endDate) : undefined,
  });

  const handleDayClick = (day) => {
    const newRange = addToRange(day, range);
    setRange(newRange);
  };

  useEffect(() => {
    if (range) {
      onSelection(range);
    }
  }, [range, onSelection]);

  const { from, to } = range || {};
  const modifiers = { start: from, end: to };

  return (
    <div
      className={`calendar-container border rounded p-3 ${classes.join(" ")}`}
    >
      <div className="no-margin text-center overflow-hidden mb-3">
        {!from && !to && (
          <span className="text-muted float-left">
            Please select the first day.
          </span>
        )}
        {from && !to && (
          <span className="text-muted float-left">
            Please select the last day.
          </span>
        )}
        {from && to && (
          <DateRangeLabel
            background="white"
            title={label}
            startDate={from}
            endDate={to}
          />
        )}
      </div>
      <DayPicker
        className={`bg-white rounded border mb-3 d-flex align-items-center justify-content-${align}`}
        numberOfMonths={numberOfMonths}
        mode="range"
        defaultMonth={from}
        selected={[from, { from, to }]}
        modifiersClassNames={{
          selected: "my-selected",
          today: "my-today",
          range_start: "my-range_start",
          range_end: "my-range_end",
        }}
        modifiers={modifiers}
        onDayClick={handleDayClick}
      />
    </div>
  );
};

export default DateRangePicker;
